<script>
import ClickButton from 'linna/components/ClickButton'

import cursor from 'linna/services/cursor'
import time from 'linna/services/time'
import viewport from 'linna/services/viewport'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Debug',

  components: {
    ClickButton
  },

  data () {
    return {
      cursor,
      viewport,
      time
    }
  },

  computed: {
    ...mapGetters([
      'currentChapter',
      'notebookPages',
      'playerLocationX',
      'playerLocationY',
      'radios',
      'radioTransmissions'
    ])
  },

  methods: {

    ...mapActions([
      'addRadioTransmission',
      'endRadioTransmissionById'
    ])

  }
}
</script>

<template>
  <div class="c-debug">

    <p>
      Current chapter: {{ currentChapter }}
    </p>

    <p>
      playerLocationX: {{ playerLocationX }}
    </p>

    <p>
      playerLocationY: {{ playerLocationY }}
    </p>

    <h1>Notebook</h1>

    <pre
      v-for="(notebookPage, i) in notebookPages"
      :key="i"
    >{{ notebookPage }}</pre>

    <h1>Radios: {{ radios.length }}</h1>

    <table>
      <tbody>

        <tr
          v-for="radio in radios"
          :key="radio.id"
        >
          <th>{{ radio.id }}</th>
          <th>{{ radio.locationX }}</th>
          <th>{{ radio.locationY }}</th>
          <th>{{ radio.frequency }}</th>
          <th>{{ radio.maxFrequency }}</th>
          <th>{{ radio.minFrequency }}</th>
          <th>{{ radio.range }}</th>
        </tr>

      </tbody>
    </table>

    <h1>Radio transmissions: {{ radioTransmissions.length }}</h1>

    <table>
      <tbody>

        <tr
          v-for="radioTransmission in radioTransmissions"
          :key="radioTransmission.id"
        >
          <th>{{ radioTransmission.id }}</th>
          <th>{{ radioTransmission.frequency }}</th>
          <th>{{ radioTransmission.originX }}</th>
          <th>{{ radioTransmission.originY }}</th>
          <th>{{ radioTransmission.range }}</th>
          <td>{{ radioTransmission.message }}</td>
          <td>
            <click-button
              @click="endRadioTransmissionById(radioTransmission.id)"
            >
              Remove
            </click-button>
          </td>
        </tr>

      </tbody>
    </table>

    <h1>Cursor</h1>

    <table>

      <tbody>

        <tr>
          <th>X</th>
          <td>{{ cursor.x }}</td>
        </tr>

        <tr>
          <th>Y</th>
          <td>{{ cursor.y }}</td>
        </tr>

        <tr>
          <th>Width</th>
          <td>{{ viewport.width }}</td>
        </tr>

        <tr>
          <th>Height</th>
          <td>{{ viewport.height }}</td>
        </tr>

        <tr>
          <th>Current time</th>
          <td>{{ time.current }}</td>
        </tr>

      </tbody>

    </table>

  </div>
</template>

<style lang="scss" scoped>

h1 {
  @include push-top-even;
  @include buffer-top-even;
  border-top-width: 0.1rem;
}

</style>
